import {HTTP_METHODS} from '../httpMethods'

const UNSAFE_SEGMENT_PATTERN = /(\.\.|\/|\\|%2f|%5c|%2e%2e)/i

const toSafeIdentifier = value => {
  const raw = String(value ?? '').trim()

  if (!raw || UNSAFE_SEGMENT_PATTERN.test(raw)) {
    throw new Error(`Unsafe path segment: ${raw}`)
  }

  return raw
}

const toSafePathSegment = value => {
  return encodeURIComponent(toSafeIdentifier(value))
}

export const PRODUCT_COMBO_CONFIG = {
  SAVE_PRODUCT_COMBO: {
    endPoint: 'combo-product',
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
    headers: {
      scope: 'pepsi',
    },
  },

  CHECK_NAME_UNIQUE: name => ({
    endPoint: `combo-product/validate-name?${new URLSearchParams({name: String(name ?? '')}).toString()}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
  }),

  GET_COMBO_PRODUCT_PROMOTION: comboProductId => ({
    endPoint: `promotion?${new URLSearchParams({comboProductId: toSafeIdentifier(comboProductId)}).toString()}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.GET,
  }),

  DELETE_COMBO_PRODUCT: comboProductId => ({
    endPoint: `combo-product/${toSafePathSegment(comboProductId)}`,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.DELETE,
  }),
}
